import config from './configs/config.mjs';

/** @type {import('./configs/config.test.mjs').default} */
const _baseConfig = config;
const _overrides = {
	editors: [],
	loader: {},
	loaderProtocolHandlers: {},
};

const _flags = {
	strictSafe: false,
};

export default class FormanConfig {
	static get config() {
		return _baseConfig;
	}

	static get overrides() {
		return _overrides;
	}

	static get flags() {
		return _flags;
	}
}
